var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadowHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.07,
    x: 0.553223,
    y: 0.142822,
    width: 31.4043,
    height: 36.5714,
    rx: 15.7021,
    fill: "#EB6753"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_424_3012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2317 24.9302H13.2789C12.7859 24.9291 12.3134 24.7006 11.9648 24.2947C11.6162 23.8887 11.42 23.3385 11.4191 22.7644V16.3969C11.4201 16.0421 11.496 15.693 11.6402 15.3805C11.7845 15.068 11.9925 14.8016 12.246 14.6049L15.2085 12.2928C15.517 12.0475 15.8818 11.9163 16.2553 11.9163C16.6288 11.9163 16.9937 12.0475 17.3021 12.2928L20.2786 14.6049C20.5302 14.803 20.7362 15.07 20.8785 15.3824C21.0209 15.6949 21.0952 16.0432 21.0951 16.3969V22.7644C21.0941 23.3392 20.8974 23.8901 20.5481 24.2961C20.1987 24.7022 19.7253 24.9302 19.2317 24.9302ZM16.2553 12.7926C16.0354 12.7933 15.8205 12.8696 15.6377 13.012L12.6578 15.3241C12.506 15.442 12.3815 15.6014 12.2951 15.7885C12.2087 15.9756 12.1631 16.1845 12.1623 16.3969V22.7644C12.1623 23.1092 12.2799 23.44 12.4893 23.6838C12.6987 23.9277 12.9828 24.0647 13.2789 24.0647H19.2317C19.5279 24.0647 19.8119 23.9277 20.0213 23.6838C20.2307 23.44 20.3483 23.1092 20.3483 22.7644V16.3969C20.3487 16.1831 20.3036 15.9726 20.2172 15.784C20.1307 15.5954 20.0056 15.4346 19.8529 15.316L16.8729 13.012C16.6902 12.8694 16.4753 12.793 16.2553 12.7926Z",
    fill: "#181A20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7654 21.8948H17.7418V22.7603H14.7654V21.8948Z",
    fill: "#181A20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_424_3012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5617,
    height: 14.6286,
    fill: "white",
    transform: "translate(9.97449 11.1143)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowHome);
export default __webpack_public_path__ + "static/media/shadow-home.056831525e6143e65df02f8a8a2f2d33.svg";
export { ForwardRef as ReactComponent };